import { render, staticRenderFns } from "./GradesMustGoUp2.vue?vue&type=template&id=38307e7a&"
import script from "./GradesMustGoUp2.vue?vue&type=script&lang=js&"
export * from "./GradesMustGoUp2.vue?vue&type=script&lang=js&"
import style0 from "./GradesMustGoUp2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
